module.exports = __webpack_public_path__ + "static/mother-and-daughter-in-the-kitchen.62ab0401.webp";